"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
import { ColorBlock } from "@repo/ui/color-block";
import { Carousel, CarouselContent, CarouselItem, CarouselPrevious, CarouselNextWithProgress, useCarousel } from "@repo/ui/carousel";
import { cn } from "@repo/ui/utils";
import { isDarkBackground } from "@/lib/color-utils";
import { VisualWrapper } from "@/components/common/visual/visual.component";
import { RichTextCondensed } from "@/components/common/rich-text/rich-text-condensed.component";
import { CardLogo } from "./image-feature-carousel-card-logo.component";
import type { ImageFeatureCarouselProps, ImageFeatureCarouselCard } from "./image-feature-carousel.types";
export function ImageFeatureCarousel(t0) {
  const $ = _c(5);
  const {
    cards,
    className
  } = t0;
  let t1;
  if ($[0] !== cards) {
    t1 = <ImageFeatureCarouselInner cards={cards} />;
    $[0] = cards;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== className || $[3] !== t1) {
    t2 = <Carousel align="start" loop={true} duration={40} className={className}>{t1}</Carousel>;
    $[2] = className;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}
function ImageFeatureCarouselInner(t0) {
  const $ = _c(51);
  const {
    cards
  } = t0;
  const {
    api
  } = useCarousel();
  const [activeIndex, setActiveIndex] = useState(0);
  const active = cards[activeIndex];
  let t1;
  let t2;
  if ($[0] !== api) {
    t1 = () => {
      if (!api) {
        return;
      }
      const onSelect = () => setActiveIndex(api.selectedScrollSnap());
      api.on("select", onSelect);
      return () => {
        api.off("select", onSelect);
      };
    };
    t2 = [api];
    $[0] = api;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  if (!active) {
    return null;
  }
  const colour = active.colour ?? "bright-blue";
  let T0;
  let isDark;
  let navigation;
  let t10;
  let t11;
  let t12;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[3] !== activeIndex || $[4] !== cards || $[5] !== colour) {
    isDark = isDarkBackground(colour);
    let t13;
    if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
      t13 = <div className="flex items-center gap-2"><CarouselPrevious /><CarouselNextWithProgress autoplayDelay={6000} /></div>;
      $[19] = t13;
    } else {
      t13 = $[19];
    }
    navigation = t13;
    t11 = "image-feature-carousel";
    t12 = "relative w-full overflow-hidden";
    t9 = "flex flex-col mobile:relative mobile:aspect-[45/26] mobile:flex-row mobile:items-end mobile:overflow-clip mobile:px-16 mobile:py-12";
    let t14;
    if ($[20] !== cards) {
      t14 = cards.map(_temp);
      $[20] = cards;
      $[21] = t14;
    } else {
      t14 = $[21];
    }
    if ($[22] !== t14) {
      t10 = <div className="relative aspect-[390/267] w-full overflow-hidden rounded-t-md mobile:absolute mobile:inset-0 mobile:aspect-auto mobile:rounded-none [&>div]:h-full"><CarouselContent className="h-full -ml-0">{t14}</CarouselContent></div>;
      $[22] = t14;
      $[23] = t10;
    } else {
      t10 = $[23];
    }
    T0 = ColorBlock;
    t6 = "rectangle-sm";
    t7 = colour;
    t8 = "flex w-full rounded-none rounded-b-sm mobile:max-w-[390px] mobile:rounded-sm tablet:max-w-[421px] tablet:rounded-md";
    t5 = "relative z-10 flex w-full flex-col justify-between items-start p-6 h-[412px] overflow-hidden tablet:h-[544px]";
    t3 = "grid";
    t4 = cards.map((card_0, idx) => <div key={card_0.key} aria-hidden={idx !== activeIndex} inert={idx !== activeIndex ? true : undefined} className={cn("col-start-1 row-start-1 flex flex-col gap-4 transition-opacity duration-500", isDark && "dark", idx === activeIndex ? "opacity-100" : "opacity-0 pointer-events-none")}><h3 className="typography-mobile-heading-h5 desktop:typography-desktop-heading-h5 text-text-primary line-clamp-3" title={card_0.headline}>{card_0.headline}</h3>{card_0.bodyCopy && <RichTextCondensed richText={card_0.bodyCopy} as="body-medium" compact={true} className="text-text-primary" />}</div>);
    $[3] = activeIndex;
    $[4] = cards;
    $[5] = colour;
    $[6] = T0;
    $[7] = isDark;
    $[8] = navigation;
    $[9] = t10;
    $[10] = t11;
    $[11] = t12;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
    $[18] = t9;
  } else {
    T0 = $[6];
    isDark = $[7];
    navigation = $[8];
    t10 = $[9];
    t11 = $[10];
    t12 = $[11];
    t3 = $[12];
    t4 = $[13];
    t5 = $[14];
    t6 = $[15];
    t7 = $[16];
    t8 = $[17];
    t9 = $[18];
  }
  let t13;
  if ($[24] !== t3 || $[25] !== t4) {
    t13 = <div className={t3}>{t4}</div>;
    $[24] = t3;
    $[25] = t4;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== active || $[28] !== isDark) {
    t14 = <CardLogo card={active} isDark={isDark} />;
    $[27] = active;
    $[28] = isDark;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  let t15;
  if ($[30] !== navigation || $[31] !== t14) {
    t15 = <div className="flex w-full items-end justify-between">{t14}{navigation}</div>;
    $[30] = navigation;
    $[31] = t14;
    $[32] = t15;
  } else {
    t15 = $[32];
  }
  let t16;
  if ($[33] !== t13 || $[34] !== t15 || $[35] !== t5) {
    t16 = <div className={t5}>{t13}{t15}</div>;
    $[33] = t13;
    $[34] = t15;
    $[35] = t5;
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  let t17;
  if ($[37] !== T0 || $[38] !== t16 || $[39] !== t6 || $[40] !== t7 || $[41] !== t8) {
    t17 = <T0 variant={t6} color={t7} className={t8}>{t16}</T0>;
    $[37] = T0;
    $[38] = t16;
    $[39] = t6;
    $[40] = t7;
    $[41] = t8;
    $[42] = t17;
  } else {
    t17 = $[42];
  }
  let t18;
  if ($[43] !== t10 || $[44] !== t17 || $[45] !== t9) {
    t18 = <div className={t9}>{t10}{t17}</div>;
    $[43] = t10;
    $[44] = t17;
    $[45] = t9;
    $[46] = t18;
  } else {
    t18 = $[46];
  }
  let t19;
  if ($[47] !== t11 || $[48] !== t12 || $[49] !== t18) {
    t19 = <div data-testid={t11} className={t12}>{t18}</div>;
    $[47] = t11;
    $[48] = t12;
    $[49] = t18;
    $[50] = t19;
  } else {
    t19 = $[50];
  }
  return t19;
}
function _temp(card) {
  return <CarouselItem key={card.key} className="basis-full pl-0">{card.image ? <VisualWrapper visual={card.image} className="h-full w-full" visualClassName="h-full w-full object-cover" imgClassName="object-cover" /> : <div className="h-full w-full bg-surface-base-secondary" />}</CarouselItem>;
}